<template>
    <div color="danger" class="impersonation-alert rounded-none bg-rose-100 px-5 py-3 flex items-center gap-3 w-full">
        <div class="text-rose-500">
            <font-awesome-icon widthAuto :icon="faTriangleExclamation" />
        </div>
        <div class="text-sm flex flex-col gap-2 justify-between items-start md:flex-row md:grow md:items-center">
            <span
                >You are impersonating <strong>{{ userName }}</strong> {{ props.userRole }} of
                <strong>{{ teamName }}</strong></span
            >
            <vx-button href="/spark/kiosk/users/stop-impersonating" color="danger" size="sm">
                Stop Impersonating
                <font-awesome-icon widthAuto :icon="faSquareArrowUpLeft"></font-awesome-icon>
            </vx-button>
        </div>
    </div>
</template>

<script setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSquareArrowUpLeft, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    userRole: {
        type: String,
        required: true,
    },
});

const userName = Spark.state.user.name;
const teamName = Spark.state.currentTeam.name;
</script>
